import { env } from '../../env';
export function getReleaseNotes() {
  return env.REACT_APP_RELEASE_NOTES
}

export default getReleaseNotes;